import React, { useRef, useEffect, useState } from "react";
import { default as TimelinesChart } from "timelines-chart";
import { useTCDataHook } from "./TimeChartVM";
import { onTableRowClick } from "../table-panels/TablePanelsVM";
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
import { observerAddToHandles } from "../../../handles/Handles";

var dateIndexlayer = {}
interface PayloadData {
  optionId: number,
  optionName: string,
  optionLayerName: string,
  optionIndex: number,
}



const TimeChartWidget = (props: any) => {
  let view = props.view;
  const payload: any = useTCDataHook();
  const [visible, setVisible] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [showRadioPanel, setShowRadioPanel] = useState(false);
  
  // useEffect(() => {
  //   buildTimeChart();
  // }, []);

  const TimeChartWidgetDiv = useRef(null);
  const chartitDiv = useRef(null);

  let dateswitcherdiv = document.getElementById("dateswitcherdiv");


  const [options, setOptions] = useState({ optionId: '', optionName: '', optionLayerName: '', optionIndex: '' });


  const addOption = (event, o) => {
    const { name } = event.target
    dateIndexlayer[o.variantOptionLayerName] = o.variantOptionIndex;
    const aa = dataList.map((itm) => {

      if (itm.variantName === name) {
        itm.variantOptions.map((i) => {
          if (i.variantOptionId === o.variantOptionId) {
            i.checked = true
          } else {
            i.checked = false
          }
          return i
        })
      }
      return itm
    })
    setDataList(aa)
    setOptions({
      optionId: o.variantOptionId,
      optionName: o.variantOptionName,
      optionLayerName: o.variantOptionLayerName,
      optionIndex: o.variantOptionIndex
    });

    buildTimeChart();
    // resetTabArray();
  };


  useEffect(() => {
  }, [options.optionName])


  useEffect(() => {
    if (props.activeWidget === 'Time Chart') {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [props.activeWidget]);

  useEffect(() => {
    if (TimeChartWidgetDiv.current) {



    }
  }, []);

  let style = { display: "initial" };

  if (visible) {
    style.display = "initial";
  } else {
    style.display = "none";
  }



  const buildsettingspanel = () => {
    setShowRadioPanel(!showRadioPanel);
  }




  const buildTimeChart = () => {

    let featurelist = {};
    let chartdata: any[] = [];
    let varientdata = [];
    let layerDateFields = {};
    let datecount = 0;
    let groupindex = 0;
    let optionsindex = 0;
    if (payload.length > 0) {
      payload.forEach(function (item, index) {
        groupindex += 1;
        let variantoptions = [];

        let groupvarient = {};
        let hasDate = false;
        let dateFields = [];
        let band1 = [];
        let band2 = [];
        let groupband1 = {};
        let groupband2 = {};
        let switchband = false;
        let groupbands = [];
        let grouplayer: {};
        var addhtml: any;
        var dateIdx = 0;

        let layername = item.layerName;
        groupvarient['variantId'] = groupindex
        groupvarient['variantName'] = layername
        item.features[0].popupTemplate.fieldInfos.forEach(function (fieldinfo) {
          if ((fieldinfo.format) && (fieldinfo.visible)) {
            if (fieldinfo.format.dateFormat) {
              hasDate = true;
              let variantoption = {};
              optionsindex += 1
              dateFields.push(fieldinfo.fieldName);

              variantoption['variantOptionId'] = optionsindex
              variantoption['variantOptionName'] = fieldinfo.fieldName
              variantoption['variantOptionLayerName'] = layername
              variantoption['variantOptionIndex'] = dateIdx
              variantoptions.push(variantoption)
              dateIdx += 1
            }
          }
        });

        // Make
        // if (dateIndexlayer[layername]) {
        //   variantoptions[dateIndexlayer[layername]]['checked'] = true
        // } else {
        //   variantoptions[0]['checked'] = true
        // }
        // groupvarient['variantOptions'] = variantoptions


        if (hasDate) {
           // Make
        if (dateIndexlayer[layername]) {
          variantoptions[dateIndexlayer[layername]]['checked'] = true
        } else {
          variantoptions[0]['checked'] = true
        }
        groupvarient['variantOptions'] = variantoptions
          //dateValues
          datecount += 1;
          let dateclass = "datefieldradio"
          let datename = "datefieldradio" + datecount
          layerDateFields[layername] = dateFields;
          let checked = false;
          let dateIndex = 0;
          if (dateIndexlayer[layername]) {
            dateIndex = dateIndexlayer[layername];
          }

          const updatedData = varientdata

          if (updatedData) {
            setDataList(updatedData)
          }

          item.features.forEach(function (feature, index) {
            let dateValues = [];
            let fieldname = "";
            let addon;
            let buildlist = [];
            let content;
            let popuptemplate = feature.popupTemplate;
            dateFields.forEach(function (x) {
              dateValues.push(feature.attributes[x]);
            })
            popuptemplate.content.forEach(function (item, index) {
              let type = item.type;
              let title = item.title;
              if (type == "fields") {
                if (title) {
                  if (title.length > 0) {
                    buildlist.push("<b>" + title + "</b>");
                    buildlist.push("<br>");
                  }
                }
              }
              if (type == "text" && item.text.length > 0) {
                if (item.text) {
                  if (item.text.length > 0) {
                    buildlist.push("<b>" + item.text + "</b>");
                    buildlist.push("<br>");
                  }
                }
              }
            });

            if (buildlist.length > 0) {
              content = buildlist.join("");
            }

            let AttributekeyChain = {};

            if (popuptemplate.title.includes("{")) {
              let customTitle = [];
              var arrStr = popuptemplate.title.split(/[{}]/);
              for (const [key, value] of Object.entries(
                feature.attributes
              )) {
                AttributekeyChain[key.toLowerCase()] = key;
              }
              for (var i = 0; i < arrStr.length; i++) {
                if (AttributekeyChain[arrStr[i].toLowerCase()]) {
                  customTitle.push(
                    " " +
                    feature.attributes[
                    AttributekeyChain[arrStr[i].toLowerCase()]
                    ]
                  );
                } else {
                  if (i === 0) {
                    customTitle.push(arrStr[i]);
                  } else {
                    customTitle.push(" " + arrStr[i]);
                  }
                }
              }
              fieldname = customTitle.join("");
            } else {
              fieldname = popuptemplate.title;
            }

            var d1 = new Date(dateValues[dateIndex]);
            var d = new Date(dateValues[dateIndex])
            var d2 = new Date(d.setMonth(d.getMonth() + 4));
            var displaydate;
            if (dateValues[dateIndex]) {
              displaydate = d1;
            } else {
              displaydate = "NO DATE ENTERED"
            }

            let featuredata = {
              timeRange: [d1, d2],
              val: layername,
              labelVal: fieldname + '   ' + displaydate + ' *OID:' + feature.attributes.OBJECTID + '/' + layername
            }
            featurelist[feature.attributes.OBJECTID + '/' + layername] = feature;
            if (switchband) {
              band2.push(featuredata)
              switchband = false
            } else {
              band1.push(featuredata)
              switchband = true
            }

          })// End of Feature
          if (band1.length > 0) {
            groupband1 = {
              label: layername,
              data: band1
            }
            groupbands.push(groupband1)
          }

          if (band2.length > 0) {
            groupband2 = {
              label: layername,
              data: band2
            }
            groupbands.push(groupband2)
          }

          if (groupbands.length > 0) {
            grouplayer = {
              group: layername,
              data: groupbands,
              "test": "test"
            }
            chartdata.push(grouplayer);
          }
          //Has Date Layer END

          varientdata.push(groupvarient);
    
          setOptions({
            optionId: varientdata[0].variantOptions[0].variantOptionId,
            optionName: varientdata[0].variantOptions[0].variantOptionName,
            optionLayerName: varientdata[0].variantOptions[0].variantOptionLayerName,
            optionIndex: varientdata[0].variantOptions[0].variantOptionIndex
          });

        } else {
          console.error('No date field found for ' + layername + '.')
        }

       
      }) // END OF PAYLOAD


      document.getElementById("chartit").innerHTML = "";
      if (chartdata.length > 0){
        document.getElementById("chartit").innerHTML = "";
      const timeline = TimelinesChart();
      timeline.width(1700)
      timeline.leftMargin(250)
      timeline.rightMargin(250)
      timeline.data(chartdata).zScaleLabel(" ").zQualitative(true)(
        document.getElementById("chartit")
      );

      timeline.onSegmentClick(function (response) {
        if (response['labelVal'].split('*OID:')) {
          onTableRowClick(view, featurelist[response['labelVal'].split('*OID:')[1]])
        }
      });
      } else {
        console.log('No Feature with Date Field')
      }
      


    } else {
      alert("Please make a selection.");
      console.log("No features selected.");
    }

  };
  return (
    <div ref={TimeChartWidgetDiv} style={style}>
      <div ref={chartitDiv} className="time-widget">
        <b>Build Time Chart</b>
        <button
          className="esri-widget--button esri-icon-line-chart geometry-button"
          id="time-chart-button"
          value="Time Chart"
          title="Time Chart"
          onClick={(e) => buildTimeChart()}
        ></button>
        <div id="chartit"></div>
        <button
          className="esri-widget--button esri-icon-settings geometry-button"
          id="time-chart-settings-button"
          value="Layer date field selection"
          title="Layer date field selection"
          onClick={(e) => buildsettingspanel()}
        ></button>
        <br />
        {showRadioPanel &&
          <div>
            {dataList.length > 0 && dataList.map((x, i) =>
              <label key={i}>
                <div>
                  <b>{x.variantName}</b>
                </div>
                {x.variantOptions.map((y, i) => {
                  return (
                    <div key={y.variantOptionId}>
                      <input
                        type="radio"
                        name={x.variantName}
                        value={y.variantOptionId}
                        checked={y?.checked}
                        onClick={(e) => addOption(e, y)}
                      // key={y.variantOptionId}
                      />
                      {y.variantOptionName}
                    </div>
                  );
                })}
                <br />
              </label>)}
          </div>
        }
      </div>
    </div>
  );
};

export default TimeChartWidget;